import React, { useEffect, useState, Fragment } from 'react';
import { SparklesIcon, CheckIcon, VideoIcon, ChevronDownIcon, XIcon, CornerDownRightIcon } from 'lucide-react';
import { CountdownTimer } from '../components/CountdownTimer';
import { SocialProofPopup } from '../components/SocialProofPopup';
import { UrgencyScarcity } from '../components/UrgencyScarcity';
const PURCHASE_LINK = 'https://f13dpf-q0.myshopify.com/cart/47511845830810:1?channel=buy_button';
const PRODUCT_IMAGE = 'https://cdn.magicpatterns.com/uploads/btVfW5Ztsf5z8ZFMXhozWf/Sin_titulo_(14_x_6_cm).png';
const RECRUITMENT_GUIDE_IMAGE = 'https://cdn.magicpatterns.com/uploads/ai5HZQKrQPdzo6UGXmiNag/Diseno_sin_titulo_(13).png';
const BONUS1_IMAGE = 'https://cdn.magicpatterns.com/uploads/hePzTgANxq5uEmiJv5jGxb/ChatGPT_Image_3_jul_2026,_01_00_30_a.m.png';
const BONUS2_IMAGE = 'https://cdn.magicpatterns.com/uploads/svm9HVj5a9NAXxDKtZvte8/ChatGPT_Image_3_jul_2026,_01_07_54_a.m.png';
const BONUS3_IMAGE = 'https://cdn.magicpatterns.com/uploads/wCdMLwq9KH2RUZ1z6fCvg7/ChatGPT_Image_3_jul_2026,_01_10_55_a.m.png';
const ELITE_PACK_LINK = 'https://f13dpf-q0.myshopify.com/cart/47516590014618:1?channel=buy_button';
const BONUS4_IMAGE = 'https://cdn.magicpatterns.com/uploads/aNTARjqhAyZD2YGNtmgaeb/WhatsApp_Image_2026-07-03_at_23.20.56.jpg';
const BONUS5_IMAGE = 'https://cdn.magicpatterns.com/uploads/4T5FetzAayYTsK5riZpoBU/WhatsApp_Image_2026-07-03_at_23.23.13_(1).jpg';
const BONUS6_IMAGE = 'https://cdn.magicpatterns.com/uploads/hFkfzDFZs51SSEahjvgZAT/WhatsApp_Image_2026-07-03_at_23.23.13.jpg';
// Bonos con su valor real (tachado) — hoy todos GRATIS con la compra.
const BONUS_SAVINGS: {
  n: number;
  title: string;
  price: string;
}[] = [{
  n: 1,
  title: 'El Script Perfecto de DM',
  price: '$14.990 ARS'
}, {
  n: 2,
  title: 'Banco de Plantillas, Ideas y Recursos',
  price: '$17.990 ARS'
}, {
  n: 3,
  title: 'Calendario de Contenido',
  price: '$19.990 ARS'
}, {
  n: 4,
  title: 'Comunidad Privada de Alumnas Nu Skin UGC',
  price: '$24.990 ARS'
}, {
  n: 5,
  title: 'Guía Cómo ser Embajadora de Viajes',
  price: '$29.990 ARS'
}, {
  n: 6,
  title: 'Masterclass de Edición en CapCut',
  price: '$34.990 ARS'
}];
const TOTAL_BONUS_VALUE = '$142.940 ARS';
// Precio tachado en rojo + cartel "HOY GRATIS".
function BonusPrice({
  price
}: {
  price: string;
}) {
  return <div className="flex items-center justify-center gap-3 mt-4" data-id="element-55">
      <span className="text-lg md:text-xl font-black text-[#E11D48] line-through" style={{
      fontFamily: 'Montserrat, sans-serif'
    }} data-id="element-56">
        {price}
      </span>
      <span className="inline-flex items-center gap-1 text-white font-black text-xs md:text-sm px-3 py-1.5 rounded-full uppercase tracking-wide bg-[#10B981]" style={{
      fontFamily: 'Montserrat, sans-serif'
    }} data-id="element-57">
        🎉 Hoy Gratis
      </span>
    </div>;
}
// Devuelve un Date "desplazado" a la hora de Argentina (Buenos Aires),
// de modo que getDay()/getDate()/getMonth() reflejen el calendario argentino.
function getArgentinaNow(): Date {
  const parts = new Intl.DateTimeFormat('en-US', {
    timeZone: 'America/Argentina/Buenos_Aires',
    year: 'numeric',
    month: 'numeric',
    day: 'numeric',
    hour: 'numeric',
    minute: 'numeric',
    second: 'numeric',
    hour12: false
  }).formatToParts(new Date());
  const get = (type: string) => parts.find(p => p.type === type)?.value ?? '0';
  return new Date(parseInt(get('year'), 10), parseInt(get('month'), 10) - 1, parseInt(get('day'), 10), parseInt(get('hour'), 10) % 24, parseInt(get('minute'), 10), parseInt(get('second'), 10));
}
function StarRating() {
  return <div className="flex gap-0.5 text-yellow-400 text-xl" data-id="element-58">{'⭐'.repeat(5)}</div>;
}
const FAQ_ITEMS: {
  question: string;
  answer: string;
}[] = [{
  question: '¿Funciona si tengo muy pocos seguidores?',
  answer: 'Sí. El algoritmo de Instagram y TikTok distribuye el contenido basado en relevancia y retención, no en número de seguidores. Cuentas de 200 seguidores han generado ventas reales aplicando estos principios. Lo que importa no es cuántos te siguen — es qué tan magnético es tu contenido.'
}, {
  question: '¿Tengo que saber editar video?',
  answer: 'No. El sistema está diseñado para grabarse y publicarse directamente desde el celular usando las herramientas nativas de Instagram Reels o TikTok. Sin CapCut avanzado. Sin Premiere. Sin nada que no sepas hacer ya.'
}, {
  question: '¿Funciona solo para la LumiSpa o para todos los productos Nu Skin?',
  answer: 'Para todos. El Método Formula UGC se adapta a cualquier producto, tecnología o suplemento: Galvánica Spa, ageLOC, Boost, TR90, Epoch. Hay estructuras y ganchos específicos para cada categoría de producto.'
}, {
  question: '¿La guía de reclutamiento es solo para emprendedoras nuevas?',
  answer: 'Funciona para cualquier nivel, pero está especialmente diseñada para quienes están construyendo su primera línea descendente y no saben cómo hablar del negocio en redes sin sonar a "es una pirámide".'
}, {
  question: '¿En cuánto tiempo veo los primeros resultados?',
  answer: 'Las primeras interacciones y DMs llegan en 24-72 horas después del primer Reel bien estructurado. Las primeras ventas orgánicas suelen ocurrir entre el día 3 y el día 14, dependiendo de tu constancia y tu audiencia actual.'
}, {
  question: '¿Qué pasa si lo compro y no funciona para mí?',
  answer: 'Tenés 7 días de garantía total. Sin preguntas. Sin condiciones. Sin formularios. Escribís un mensaje y te devuelvo el dinero completo. Así de simple.'
}];
function FaqAccordion() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  return <div className="space-y-3" data-id="element-59">
      {FAQ_ITEMS.map((item, index) => {
      const isOpen = openIndex === index;
      return <div key={index} className={`rounded-2xl border overflow-hidden transition-all duration-300 ${isOpen ? 'border-[#85C3D7] bg-white shadow-[0_10px_30px_-12px_rgba(133,195,215,0.55)]' : 'border-gray-200 bg-white hover:border-[#98CBDD] shadow-sm'}`} data-id="element-60">
            <button type="button" onClick={() => setOpenIndex(isOpen ? null : index)} aria-expanded={isOpen} className="w-full flex items-center justify-between gap-4 text-left px-5 md:px-6 py-5" data-id="element-61">
              <span className={`font-black text-base md:text-lg leading-snug transition-colors duration-200 ${isOpen ? 'text-black' : 'text-gray-900'}`} style={{
            fontFamily: 'Montserrat, sans-serif'
          }} data-id="element-62">
                {item.question}
              </span>
              <span className={`flex-shrink-0 w-9 h-9 rounded-full flex items-center justify-center transition-all duration-300 ${isOpen ? 'bg-[#85C3D7] text-white rotate-180' : 'bg-gray-100 text-gray-500'}`} data-id="element-63">
                <ChevronDownIcon className="w-5 h-5" strokeWidth={2.5} data-id="element-64" />
              </span>
            </button>
            <div className={`grid transition-all duration-300 ease-in-out ${isOpen ? 'grid-rows-[1fr] opacity-100' : 'grid-rows-[0fr] opacity-0'}`} data-id="element-65">
              <div className="overflow-hidden" data-id="element-66">
                <p className="px-5 md:px-6 pb-5 text-gray-600 text-sm md:text-[15px] leading-relaxed" data-id="element-67">
                  {item.answer}
                </p>
              </div>
            </div>
          </div>;
    })}
    </div>;
}
export function SalesPage() {
  // Re-renderiza cada minuto para que el día cambie automáticamente al pasar
  // la medianoche (00:00 hs) según el calendario de Argentina.
  const [, setTick] = useState(0);
  useEffect(() => {
    const interval = setInterval(() => setTick(t => t + 1), 60 * 1000);
    return () => clearInterval(interval);
  }, []);
  const days = ['domingo', 'lunes', 'martes', 'miércoles', 'jueves', 'viernes', 'sábado'];
  const months = ['enero', 'febrero', 'marzo', 'abril', 'mayo', 'junio', 'julio', 'agosto', 'septiembre', 'octubre', 'noviembre', 'diciembre'];
  const today = getArgentinaNow();
  const dateTextUpper = `HOY ${days[today.getDay()].toUpperCase()} ${today.getDate()} DE ${months[today.getMonth()].toUpperCase()}`;
  return <div className="w-full bg-white" style={{
    fontFamily: 'Inter, sans-serif'
  }} data-id="element-68">
      {/* STICKY URGENCY BAR */}
      <div className="sticky top-0 z-40 text-white py-3 px-4 text-center bg-[#85C3D7]" data-id="element-69">
        <div className="flex flex-wrap items-center justify-center gap-2 text-sm md:text-base font-bold" style={{
        fontFamily: 'Montserrat, sans-serif'
      }} data-id="element-70">
          <span data-id="element-71">⏳ OFERTA EXPIRA EN:</span>
          <CountdownTimer data-id="element-72" />
          <span data-id="element-73">|</span>
          <span data-id="element-74">🔥 SOLO QUEDAN 3 CUPOS {dateTextUpper} 🔥</span>
        </div>
      </div>

      {/* MAIN CONTENT */}
      <div className="max-w-3xl mx-auto px-4 py-0" data-id="element-75">
        {/* HERO SECTION */}
        <section className="py-10 text-center pt-[10px] pb-[10px]" data-id="element-76">
          {/* Tag */}
          <div className="inline-block text-white text-sm font-bold px-4 py-2 rounded-full mb-5 tracking-wide bg-[#000000] pt-[8px] pb-[8px] pl-[16px] pr-[16px]" style={{
          fontFamily: 'Montserrat, sans-serif'
        }} data-id="element-77">
            📌 Para Emprendedoras NuSkin✨
          </div>

          {/* Main Headline */}
          <h1 className="md:text-5xl font-black text-black mb-4 uppercase text-center text-[30px] pt-[10px] pb-[10px]" style={{
          fontFamily: 'Montserrat, sans-serif'
        }} data-id="element-78">
            Dejá de perseguir clientas.
            <br data-id="element-79" />
            Hacé que{' '}
            <span className="underline decoration-[#98CBDD] text-[#FCFCFC] bg-[#98CBDD]" data-id="element-80">
              ELLAS te PERSIGAN
            </span>{' '}
            a vos.
          </h1>

          {/* Product Image */}
          <div className="block mb-6" data-id="element-81">
            <img src="https://cdn.magicpatterns.com/uploads/eKTZAz1TcMYdMzRsh1bFbT/ChatGPT_Image_2_jul_2026,_09_55_38_p.m..png" alt="Megapack Fórmula UGC para Emprendedoras Nu Skin" className="w-full max-w-sm mx-auto rounded-2xl shadow-2xl" data-id="element-82" />
          </div>

          {/* Subheadline */}
          <p className="md:text-2xl text-gray-800 mb-6 font-[700] text-[18px]" style={{
          fontFamily: 'Montserrat, sans-serif'
        }} data-id="element-83">
            👉🏻{' '}
            <span className="underline decoration-[#98CBDD] decoration-4 underline-offset-2" data-id="element-84">
              Tu primera venta en menos de 7 días
            </span>{' '}
            con tu negocio de NuSkin, aunque no tengas experiencia, ni
            seguidores.
          </p>

          {/* Description */}
          <p className="text-base md:text-lg text-gray-700 mb-6 leading-relaxed" data-id="element-85">
            Aplica el método <strong data-id="element-86">FÓRMULA UGC</strong> para que tu contenido{' '}
            <strong data-id="element-87">SI VENDA</strong> por vos <strong data-id="element-88">TODOS LOS DÍAS</strong>,
            usando solo tu celular y tu rutina real.
          </p>

          {/* Negative list */}
          <div className="border-l-4 border-red-500 rounded-lg p-5 mb-8 text-left space-y-3 bg-[#FDF6EF]" data-id="element-89">
            <p className="flex items-start gap-2 text-gray-800 font-medium" data-id="element-90">
              ❌ <span data-id="element-91">Sin tener que enviar DMs en frío</span>
            </p>
            <p className="flex items-start gap-2 text-gray-800 font-medium" data-id="element-92">
              ❌{' '}
              <span data-id="element-93">
                Sin tener que iniciar conversaciones incómodas en la fila del
                súper
              </span>
            </p>
            <p className="flex items-start gap-2 text-gray-800 font-medium" data-id="element-94">
              ❌ <span data-id="element-95">Sin depender de familiares o amigos</span>
            </p>
            <p className="flex items-start gap-2 text-gray-800 font-medium" data-id="element-96">
              ❌{' '}
              <span data-id="element-97">
                Sin publicar "placas / fotos catálogo" que{' '}
                <strong data-id="element-98">NO VENDEN.</strong>
              </span>
            </p>
          </div>

          {/* CTA Button */}
          <button onClick={() => {
          document.getElementById('precio')?.scrollIntoView({
            behavior: 'smooth'
          });
        }} className="block w-full text-center bg-green-600 hover:bg-green-700 text-white font-black py-5 px-6 rounded-lg text-lg md:text-xl leading-tight transition-all duration-200 btn-pulse shadow-lg hover:shadow-xl hover:-translate-y-0.5" style={{
          fontFamily: 'Montserrat, sans-serif'
        }} data-id="element-99">
            👉🏻 SI, QUIERO DEJAR DE PERSEGUIR Y ATRAER - ACCESO INMEDIATO
          </button>
          <p className="text-sm text-gray-500 mt-3 font-medium" data-id="element-100">
            ✅ Acceso inmediato · Un solo pago · Garantía 7 días · +500 Alumnas
            Nuskin ⭐⭐⭐⭐⭐
          </p>
        </section>

        {/* DIVIDER */}
        <div className="border-t-4 border-black my-2" data-id="element-101" />

        {/* PAIN SECTION */}
        <section className="py-12 px-4 bg-gray-50" data-id="element-102">
          <div className="max-w-5xl mx-auto rounded-[32px] p-8 md:p-12 shadow-[0_8px_30px_rgb(0,0,0,0.08)] border border-gray-100 bg-[#FFDDDD]" data-id="element-103">
            <h2 className="text-3xl md:text-4xl font-black text-center mb-10 text-[#1A1D29]" style={{
            fontFamily: 'Montserrat, sans-serif'
          }} data-id="element-104">
              ¿TE IDENTIFICAS?
            </h2>

            <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-10" data-id="element-105">
              {[<Fragment data-id="element-106">
                  Sentís que tenes{' '}
                  <strong data-id="element-107">LOS MEJORES PRODUCTOS DE BELLEZA DEL MERCADO</strong>,
                  pero aún así, las clientas{' '}
                  <strong className="text-[#FFFFFF] bg-[#FD3A6B]" data-id="element-108">
                    ¿NO TE LO COMPRAN?
                  </strong>
                </Fragment>, <Fragment data-id="element-109">
                  Sentís que las{' '}
                  <strong className="text-[#FFFFFF] bg-[#FD3A6B]" data-id="element-110">
                    PERSEGUIS TODO EL TIEMPO
                  </strong>{' '}
                  ¿cuando debería de ser al revés?
                </Fragment>, <Fragment data-id="element-111">
                  Ganas{' '}
                  <strong className="text-[#FFFFFF] bg-[#FD3A6B]" data-id="element-112">
                    MENOS DE $3.000 USD AL MES
                  </strong>{' '}
                  y querés que este negocio te funcione.
                </Fragment>, <Fragment data-id="element-113">
                  Invertiste en las tecnologías, y aún{' '}
                  <strong className="text-[#FFFFFF] bg-[#FD3A6B]" data-id="element-114">
                    NO LOGRASTE RECUPERAR TU INVERSIÓN
                  </strong>
                  .
                </Fragment>, <Fragment data-id="element-115">
                  Logras vender algo pero{' '}
                  <strong className="text-[#FFFFFF] bg-[#FD3A6B]" data-id="element-116">
                    NO ES DE FORMA CONSTANTE Y PREDECIBLE
                  </strong>{' '}
                  cada mes.
                </Fragment>, <Fragment data-id="element-117">
                  Publicas fotos, mandas difusiones de Whatsapp o mensajes por
                  DM y{' '}
                  <strong className="text-[#FFFFFF] bg-[#FD3A6B]" data-id="element-118">
                    TE CLAVAN EL VISTO
                  </strong>
                  .
                </Fragment>, <Fragment data-id="element-119">
                  Te piden precio y te dicen que lo "tienen que pensar" o peor
                  aún:{' '}
                  <strong className="text-[#FFFFFF] bg-[#FD3A6B]" data-id="element-120">
                    DESAPARECEN
                  </strong>
                  .
                </Fragment>, <Fragment data-id="element-121">
                  Te frustra{' '}
                  <strong className="text-[#FFFFFF] bg-[#FD3A6B]" data-id="element-122">
                    NO GENERAR DINERO
                  </strong>{' '}
                  como esperabas.
                </Fragment>, <Fragment data-id="element-123">
                  Tenes miedo de estar{' '}
                  <strong className="text-[#FFFFFF] bg-[#FD3A6B]" data-id="element-124">
                    PERDIENDO EL TIEMPO
                  </strong>
                  .
                </Fragment>, <Fragment data-id="element-125">
                  <strong className="text-[#FFFFFF] bg-[#FD3A6B]" data-id="element-126">DUDAS</strong>{' '}
                  si este negocio es para vos.
                </Fragment>, <Fragment data-id="element-127">
                  Querés lograr el próximo rango de la empresa pero{' '}
                  <strong className="text-[#FFFFFF] bg-[#FD3A6B]" data-id="element-128">
                    ESTÁS ESTANCADA
                  </strong>
                  .
                </Fragment>].map((content, i) => <div key={i} className="flex items-start gap-3" data-id="element-129">
                  <span className="text-xl flex-shrink-0 mt-0.5" data-id="element-130">💔</span>
                  <p className="text-gray-700 text-base md:text-lg font-medium leading-relaxed" data-id="element-131">
                    {content}
                  </p>
                </div>)}
            </div>

            <div className="border-l-4 border-gray-300 pl-5 py-2 max-w-3xl mx-auto" data-id="element-132">
              <p className="text-gray-600 text-base md:text-lg italic leading-relaxed" data-id="element-133">
                Y lo peor: ves a otras líderes creciendo, vendiendo cada mes y{' '}
                <strong className="text-gray-800" data-id="element-134">NO ENTENDES CÓMO</strong>... o
                por qué a ellas les funciona y a vos no.
              </p>
            </div>
          </div>

          <div className="mt-10 text-center max-w-2xl mx-auto" data-id="element-135">
            <p className="text-lg md:text-xl text-gray-700 italic mb-2" data-id="element-136">
              Déjame decirte que te entiendo, yo también pasé por ahí.
            </p>
            <p className="text-xl md:text-2xl font-bold italic text-gray-800 mb-8" data-id="element-137">
              Pero la buena noticia es que tiene solución 🩵
            </p>

            <div className="bg-[#98CBDD] text-white rounded-2xl p-6 md:p-8 shadow-md" data-id="element-138">
              <p className="text-2xl md:text-3xl font-black" style={{
              fontFamily: 'Montserrat, sans-serif'
            }} data-id="element-139">
                El problema NO son los productos, ni el precio. Es LA
                ESTRATEGIA.
              </p>
            </div>
          </div>
        </section>

        {/* DIVIDER */}
        <div className="border-t-4 border-black my-2" data-id="element-140" />
      </div>

      {/* TRUTH SECTION - Full width black */}
      <section className="text-white py-12 px-4 bg-[#000000]" data-id="element-141">
        <div className="max-w-3xl mx-auto" data-id="element-142">
          <div className="text-center mb-4" data-id="element-143">
            <span className="inline-block text-white text-xs md:text-sm font-bold px-4 py-2 rounded-full uppercase tracking-widest bg-[#FD3A6B]" style={{
            fontFamily: 'Montserrat, sans-serif'
          }} data-id="element-144">
              EL PROBLEMA
            </span>
          </div>
          <h2 className="text-2xl md:text-3xl font-black text-center mb-8 leading-tight" style={{
          fontFamily: 'Montserrat, sans-serif'
        }} data-id="element-145">
            La verdad que nadie en tu línea ascendente
            <br data-id="element-146" />
            <span className="text-[#FFFFFF] bg-[#FD3A6B]" data-id="element-147">
              te está diciendo:
            </span>
          </h2>

          <div className="space-y-4 text-base md:text-lg text-gray-200 leading-relaxed" data-id="element-148">
            <p data-id="element-149">
              El modelo de{' '}
              <strong className="text-white" data-id="element-150">
                "hace una lista de 100 personas y contactalos uno por uno"
              </strong>{' '}
              fue diseñado en los años 80.
            </p>
            <p data-id="element-151"></p>
            <p className="text-xl font-bold text-white text-center py-4" data-id="element-152">
              Hoy, la clienta que te va a comprar{' '}
              <span className="text-[#FFFFFF] bg-[#FD3A6B]" data-id="element-153">
                NO quiere que la busques.
              </span>
              <br data-id="element-154" />
              Quiere encontrarte{' '}
              <span className="font-[800] text-[#FFFFFF] bg-[#FD3A6B]" data-id="element-155">
                ELLA sola.
              </span>
            </p>
            <p className="text-[20px] font-[800] text-[#FFFFFF] bg-[#10B981]" data-id="element-156">
              Y te encuentra EN INSTAGRAM si haces un buen CONTENIDO UGC.
            </p>
          </div>

          <div className="text-black rounded-xl p-6 my-8 text-center bg-[#FFFFFF]" data-id="element-157">
            <p className="text-base md:text-lg font-bold leading-relaxed bg-[#FFFFFF]" data-id="element-158">
              El UGC cambió la forma de consumir de las clientas. Y SI NO LO
              DOMINÁS, NO TENÉS VENTAS. Así de simple.
            </p>
          </div>

          <div className="space-y-3 text-base md:text-lg text-gray-200" data-id="element-159">
            <p className="text-center text-[20px] font-[800] text-[#FFFFFF]" data-id="element-160">
              Pero <strong className="text-[#FFFFFF] bg-[#FD3A6B]" data-id="element-161">OJO.</strong>{' '}
              NO es simplemente grabarte usando el producto. Eso lo hace
              cualquiera. ❌
            </p>
            <p className="text-center font-bold text-xl text-[#FFFFFF] bg-[#000000]" data-id="element-162">
              Se trata de una{' '}
              <span className="font-[800] text-[#FFFFFF] bg-[#FD3A6B]" data-id="element-163">
                ESTRUCTURA de videos que SI CONVIERTEN
              </span>{' '}
              en ventas.
            </p>
          </div>
        </div>
      </section>

      <div className="max-w-3xl mx-auto px-4" data-id="element-164">
        {/* PRODUCT INTRO */}
        <section className="py-10 text-center" data-id="element-165">
          <div className="text-center mb-4" data-id="element-166">
            <span className="inline-block text-xs md:text-sm font-bold px-4 py-2 rounded-full uppercase tracking-widest text-[#FFFFFF] bg-[#D7B2D8] pl-[16px] pr-[16px]" style={{
            fontFamily: 'Montserrat, sans-serif'
          }} data-id="element-167">
              LA SOLUCIÓN
            </span>
          </div>
          <h2 className="text-3xl md:text-4xl font-black text-black mb-4 leading-tight" style={{
          fontFamily: 'Montserrat, sans-serif'
        }} data-id="element-168">
            ✨ Fórmula UGC para
            <br data-id="element-169" />
            Emprendedoras Nu Skin ✨
          </h2>

          <div className="flex justify-center mb-6" data-id="element-170">
            <img src="https://cdn.magicpatterns.com/uploads/6S5k6MsQnxyBY3GvsZzzuj/ChatGPT_Image_3_jul_2026,_12_48_57_a.m.png" alt="Fórmula UGC para Emprendedoras Nu Skin" className="w-full max-w-md rounded-2xl shadow-xl" data-id="element-171" />
          </div>

          <p className="text-lg md:text-xl font-bold text-gray-700 mb-8" data-id="element-172">
            Un sistema <strong data-id="element-173">COMPLETO</strong> para que{' '}
            <strong data-id="element-174">TRANSFORMES</strong> tu forma de trabajar y tus ventas esta
            misma semana.
          </p>

          <div className="border border-gray-200 rounded-[32px] p-6 md:p-10 shadow-[0_8px_30px_rgb(0,0,0,0.08)] mb-8 bg-[#FDF6EF]" data-id="element-175">
            <h3 className="text-2xl font-black text-black mb-6 text-center bg-[#FDF6EF]" style={{
            fontFamily: 'Montserrat, sans-serif'
          }} data-id="element-176">
              ¿QUÉ VAS A LOGRAR CON ESTE PROGRAMA?
            </h3>

            <div className="space-y-3 text-left mb-8" data-id="element-177">
              <p className="flex items-start gap-2 text-base md:text-lg text-gray-800 font-medium" data-id="element-178">
                ✅{' '}
                <span data-id="element-179">
                  <strong className="text-[#FFFFFF] bg-[#10B981]" data-id="element-180">
                    DEJAR de PERSEGUIR
                  </strong>{' '}
                  clientas y que en cambio{' '}
                  <strong className="text-[#FFFFFF] bg-[#10B981]" data-id="element-181">
                    ELLAS te PERSIGAN a VOS.
                  </strong>
                </span>
              </p>
              <p className="flex items-start gap-2 text-base md:text-lg text-gray-800 font-medium" data-id="element-182">
                ✅{' '}
                <span data-id="element-183">
                  Te tomen de{' '}
                  <strong className="text-[#000000] bg-[#EBFFF3]" data-id="element-184">
                    REFERENTE
                  </strong>{' '}
                  en el mercado y{' '}
                  <strong className="text-[#000000] bg-[#EBFFF3]" data-id="element-185">
                    CONFÍEN
                  </strong>{' '}
                  en vos.
                </span>
              </p>
              <p className="flex items-start gap-2 text-base md:text-lg text-gray-800 font-medium" data-id="element-186">
                ✅{' '}
                <span data-id="element-187">
                  Te pidan info para{' '}
                  <strong className="text-[#000000] bg-[#EBFFF3]" data-id="element-188">
                    COMPRAR REALMENTE
                  </strong>{' '}
                  y NO por curiosidad.
                </span>
              </p>
              <p className="flex items-start gap-2 text-base md:text-lg text-gray-800 font-medium" data-id="element-189">
                ✅{' '}
                <span className="bg-[#FDF6EF]" data-id="element-190">
                  Tengas nuevas{' '}
                  <strong className="text-[#000000] bg-[#EBFFF3]" data-id="element-191">
                    CLIENTAS
                  </strong>{' '}
                  que{' '}
                  <strong className="text-[#000000] bg-[#EBFFF3]" data-id="element-192">
                    CONSUMEN PRODUCTOS TODOS LOS MESES
                  </strong>
                </span>
              </p>
              <p className="flex items-start gap-2 text-base md:text-lg text-gray-800 font-medium" data-id="element-193">
                ✅{' '}
                <span data-id="element-194">
                  Tengas nuevas <strong data-id="element-195">SOCIAS</strong> que{' '}
                  <strong data-id="element-196">TRABAJEN EN TU EQUIPO</strong>
                </span>
              </p>
              <p className="flex items-start gap-2 text-base md:text-lg text-gray-800 font-medium" data-id="element-197">
                ✅{' '}
                <span data-id="element-198">
                  Logres llegar al próximo{' '}
                  <strong className="text-[#FFFFFF] bg-[#10B981]" data-id="element-199">
                    RANGO DE LA COMPAÑÍA
                  </strong>
                </span>
              </p>
            </div>

            <p className="text-base text-gray-700 mb-4 font-[400]" data-id="element-200">
              Esto es exactamente lo que realmente me ayudó a despegar mi
              negocio:
            </p>

            <div className="text-white rounded-xl p-6 mb-6 bg-[#FDF6EF] pt-[0px] pb-[0px]" data-id="element-201">
              <p className="text-xl font-black mb-2 text-[#000000]" style={{
              fontFamily: 'Montserrat, sans-serif'
            }} data-id="element-202">
                🔥 Método FÓRMULA UGC
              </p>
              <p className="font-bold text-lg text-[#000000]" data-id="element-203">
                (Rutina → Problema → Solución)
              </p>
            </div>

            <div className="border border-gray-200 rounded-xl p-5 text-left mb-6 bg-[#FDF6EF] pt-[10px] pb-[10px] pl-[20px] pr-[20px]" data-id="element-204">
              <p className="text-base text-gray-800 leading-relaxed" data-id="element-205">
                <strong data-id="element-206">UGC estratégico</strong> = lograr que la persona piense:
                <br data-id="element-207" />
                <br data-id="element-208" />
                <span className="text-green-600 font-bold" data-id="element-209">
                  "ella es como yo"
                </span>{' '}
                →{' '}
                <span className="text-green-600 font-bold" data-id="element-210">"eso me pasa"</span>{' '}
                →{' '}
                <span className="text-green-600 font-bold" data-id="element-211">
                  "lo necesito" → "lo quiero."
                </span>
                .
                <br data-id="element-212" />
                <br data-id="element-213" />
                Resultado: antes de que vos respondas DM… las clientas{' '}
                <strong className="text-[#FFFFFF] bg-[#10B981]" data-id="element-214">
                  YA están decididas, te escriben Y TE COMPRAN a vos
                </strong>{' '}
                💸
              </p>
            </div>

            {/* Mid-page CTA */}
            <p className="text-sm text-gray-500 mt-3 font-[900]" data-id="element-215">
              · +500 Alumnas Nuskin ⭐⭐⭐⭐⭐
            </p>
          </div>
        </section>

        {/* DIVIDER */}
        <div className="border-t-4 border-black my-2" data-id="element-216" />

        {/* WHAT'S INCLUDED */}
        <section className="py-10" data-id="element-217">
          <h2 className="text-2xl md:text-3xl font-black text-black text-center mb-8 uppercase" style={{
          fontFamily: 'Montserrat, sans-serif'
        }} data-id="element-218">
            ¿Qué incluye exactamente?
          </h2>

          <div className="flex justify-center mb-8" data-id="element-219">
            <img src="https://cdn.magicpatterns.com/uploads/cBa9qzbkfwLJk47oktobBJ/Diseno_sin_titulo_(21).png" alt="Qué incluye exactamente" className="w-full max-w-md rounded-2xl shadow-xl" data-id="element-220" />
          </div>

          <div className="space-y-4" data-id="element-221">
            <div className="border-2 border-black rounded-xl p-5 flex gap-4 items-start bg-[#FDF6EF]" data-id="element-222">
              <div className="bg-black text-white font-black text-lg w-10 h-10 rounded-full flex items-center justify-center flex-shrink-0" style={{
              fontFamily: 'Montserrat, sans-serif'
            }} data-id="element-223">
                1
              </div>
              <div data-id="element-224">
                <p className="font-black text-black text-base" style={{
                fontFamily: 'Montserrat, sans-serif'
              }} data-id="element-225">
                  Módulo 1
                </p>
                <p className="text-gray-700 text-sm" data-id="element-226">
                  Bases y fundamentos del UGC (Contenido Generado por el
                  Usuario)
                </p>
              </div>
            </div>
            <div className="border-2 border-black rounded-xl p-5 flex gap-4 items-start bg-[#FDF6EF]" data-id="element-227">
              <div className="bg-black font-black text-lg w-10 h-10 rounded-full flex items-center justify-center flex-shrink-0 text-[#FFFFFF]" style={{
              fontFamily: 'Montserrat, sans-serif'
            }} data-id="element-228">
                2
              </div>
              <div data-id="element-229">
                <p className="font-black text-black text-base" style={{
                fontFamily: 'Montserrat, sans-serif'
              }} data-id="element-230">
                  Módulo 2
                </p>
                <p className="text-gray-700 text-sm" data-id="element-231">
                  Estructura de videos que SI VENDEN
                </p>
              </div>
            </div>
            <div className="border-2 border-black rounded-xl p-5 flex gap-4 items-start bg-[#FDF6EF]" data-id="element-232">
              <div className="bg-black text-white font-black text-lg w-10 h-10 rounded-full flex items-center justify-center flex-shrink-0" style={{
              fontFamily: 'Montserrat, sans-serif'
            }} data-id="element-233">
                3
              </div>
              <div data-id="element-234">
                <p className="font-black text-black text-base" style={{
                fontFamily: 'Montserrat, sans-serif'
              }} data-id="element-235">
                  Módulo 3
                </p>
                <p className="text-gray-700 text-sm" data-id="element-236">
                  El Arte de Cómo vender SIN VENDER
                </p>
              </div>
            </div>
            <div className="border-2 border-black rounded-xl p-5 flex gap-4 items-start bg-[#FDF6EF]" data-id="element-237">
              <div className="bg-black text-white font-black text-lg w-10 h-10 rounded-full flex items-center justify-center flex-shrink-0" style={{
              fontFamily: 'Montserrat, sans-serif'
            }} data-id="element-238">
                4
              </div>
              <div data-id="element-239">
                <p className="font-black text-black text-base" style={{
                fontFamily: 'Montserrat, sans-serif'
              }} data-id="element-240">
                  Módulo 4
                </p>
                <p className="text-gray-700 text-sm" data-id="element-241">
                  Ganchos Magnéticos que facturan
                </p>
              </div>
            </div>
            <div className="border-2 border-black rounded-xl p-5 flex gap-4 items-start bg-[#FDF6EF]" data-id="element-242">
              <div className="bg-black text-white font-black text-lg w-10 h-10 rounded-full flex items-center justify-center flex-shrink-0" style={{
              fontFamily: 'Montserrat, sans-serif'
            }} data-id="element-243">
                5
              </div>
              <div data-id="element-244">
                <p className="font-black text-black text-base" style={{
                fontFamily: 'Montserrat, sans-serif'
              }} data-id="element-245">
                  Módulo 5
                </p>
                <p className="text-gray-700 text-sm" data-id="element-246">
                  El Cierre Invisible (Protocolo 24/48/72hs)
                </p>
              </div>
            </div>
            <div className="border-2 border-black rounded-xl p-5 flex gap-4 items-start bg-[#FDF6EF]" data-id="element-247">
              <div className="bg-black text-white font-black text-lg w-10 h-10 rounded-full flex items-center justify-center flex-shrink-0" style={{
              fontFamily: 'Montserrat, sans-serif'
            }} data-id="element-248">
                6
              </div>
              <div data-id="element-249">
                <p className="font-black text-black text-base" style={{
                fontFamily: 'Montserrat, sans-serif'
              }} data-id="element-250">
                  Módulo 6
                </p>
                <p className="text-gray-700 text-sm" data-id="element-251">
                  Mentalidad de Creadora Millonaria
                </p>
              </div>
            </div>
            <div className="border-2 border-green-600 rounded-xl p-5 flex gap-4 items-start bg-[#F0FDF4]" data-id="element-252">
              <div className="bg-green-600 text-white font-black text-lg w-10 h-10 rounded-full flex items-center justify-center flex-shrink-0" style={{
              fontFamily: 'Montserrat, sans-serif'
            }} data-id="element-253">
                7
              </div>
              <div data-id="element-254">
                <p className="font-black text-black text-base" style={{
                fontFamily: 'Montserrat, sans-serif'
              }} data-id="element-255">
                  Módulo 7
                </p>
                <p className="text-gray-700 text-sm" data-id="element-256">
                  Tu próximo Nivel - De cero o pocas ventas a Vendo todas las
                  semanas
                </p>
              </div>
            </div>
          </div>
        </section>

        {/* DIVIDER */}
        <div className="border-t-4 border-black my-2" data-id="element-257" />

        {/* WHO IS YOUR MENTOR */}
        <section className="py-10" data-id="element-258">
          <div className="max-w-md mx-auto rounded-[32px] p-6 md:p-8 text-center shadow-[0_8px_30px_rgb(0,0,0,0.08)] border border-gray-100 bg-[#FDF6EF]" data-id="element-259">
            <h2 className="text-2xl md:text-3xl font-black text-[#1A1D29] mb-6 leading-tight" style={{
            fontFamily: 'Montserrat, sans-serif'
          }} data-id="element-260">
              ¿Quién será tu mentora? 💘
            </h2>

            <div className="mb-6" data-id="element-261">
              <img src="https://cdn.magicpatterns.com/uploads/74bMZb1BVUdF5PkWXd4bKG/Diseno_sin_titulo.png" alt="Brenda Hormaechea sosteniendo productos Nu Skin" className="w-full rounded-3xl shadow-lg object-cover" data-id="element-262" />
            </div>

            <h3 className="text-xl md:text-2xl font-black text-black mb-1" style={{
            fontFamily: 'Montserrat, sans-serif'
          }} data-id="element-263">
              Brenda Hormaechea
            </h3>
            <p className="text-base font-bold text-[#85C3D7] mb-3" style={{
            fontFamily: 'Montserrat, sans-serif'
          }} data-id="element-264">
              Emprendedora Nu Skin
            </p>

            <p className="text-gray-700 text-sm md:text-base leading-relaxed" data-id="element-265">
              <strong className="text-gray-900" data-id="element-266">Creadora</strong> de Contenido{' '}
              <strong className="text-gray-900" data-id="element-267">UGC</strong>, Emprendedora Nu
              Skin, Travel Influencer, Info-productora,{' '}
              <strong className="text-gray-900" data-id="element-268">Embajadora</strong> de viajes y
              Experta en{' '}
              <strong className="text-gray-900" data-id="element-269">Marketing Digital</strong>, con
              +10 años de experiencia. Creadora{' '}
              <a href="https://instagram.com/entualma.viajes" target="_blank" rel="noopener noreferrer" className="font-black text-black underline" data-id="element-270">
                @entualma.viajes
              </a>
            </p>
          </div>
        </section>

        {/* DIVIDER */}
        <div className="border-t-4 border-black my-2" data-id="element-271" />

        {/* FOR YOU / NOT FOR YOU */}
        <section className="py-10" data-id="element-272">
          <h2 className="text-2xl md:text-3xl font-black text-black text-center mb-8 uppercase" style={{
          fontFamily: 'Montserrat, sans-serif'
        }} data-id="element-273">
            ¿PARA QUIÉN ES ESTE PROGRAMA?
          </h2>
          <div className="grid md:grid-cols-2 gap-6" data-id="element-274">
            <div className="bg-green-50 border-2 border-green-600 rounded-xl p-6" data-id="element-275">
              <h3 className="text-xl font-black text-green-700 mb-4 text-center" style={{
              fontFamily: 'Montserrat, sans-serif'
            }} data-id="element-276">
                ✅ Esto es PARA vos si:
              </h3>
              <div className="space-y-3 text-sm text-gray-800" data-id="element-277">
                <p data-id="element-278">
                  ✅ Acabas de iniciar o llevas meses en NuSkin y tus ventas NO
                  llegan como esperabas
                </p>
                <p data-id="element-279">
                  ✅ No sabes qué publicar en Instagram y sólo usas las fotos
                  oficiales de la empresa
                </p>
                <p data-id="element-280">
                  ✅ Alguien te preguntó el precio, desapareció y no supiste qué
                  hacer
                </p>
                <p data-id="element-281">
                  ✅ Querés que tu perfil atraiga clientas y socias sin que
                  tengas que perseguirlas a diario
                </p>
                <p data-id="element-282">
                  ✅ Tenés menos de 60-90 minutos al día para crear contenido y
                  querés maximizar tu tiempo
                </p>
                <p data-id="element-283">
                  ✅ Ya vendés pero querés aumentar tu facturación y subir de
                  rango
                </p>
              </div>
            </div>
            <div className="bg-gray-50 border-2 border-gray-300 rounded-xl p-6" data-id="element-284">
              <h3 className="text-xl font-black text-gray-700 mb-4 text-center" style={{
              fontFamily: 'Montserrat, sans-serif'
            }} data-id="element-285">
                ❌ Esto NO es para vos si:
              </h3>
              <div className="space-y-3 text-sm text-gray-800" data-id="element-286">
                <p data-id="element-287">
                  ❌ Buscas hacerte rica de la noche a la mañana sin trabajar ni
                  aprender nuevas estrategias de venta (UGC)
                </p>
                <p data-id="element-288">❌ No estás dispuesta a mostrar ni tus manos en cámara</p>
                <p data-id="element-289">
                  ❌ Querés seguir usando el método de "amplia tu lista y
                  escríbele a tus 100 contactos"
                </p>
              </div>
            </div>
          </div>
        </section>

        {/* DIVIDER */}
        <div className="border-t-4 border-black my-2" data-id="element-290" />

        {/* BEFORE / AFTER */}
        <section className="py-10" data-id="element-291">
          <h2 className="text-2xl md:text-3xl font-black text-black text-center mb-8 uppercase" style={{
          fontFamily: 'Montserrat, sans-serif'
        }} data-id="element-292">
            ANTES vs DESPUÉS
            <br data-id="element-293" />
            <span className="text-[#10B981]" data-id="element-294">(con Fórmula UGC)</span>
          </h2>
          <div className="grid md:grid-cols-2 gap-6" data-id="element-295">
            <div className="bg-red-50 border-2 border-red-400 rounded-xl p-6" data-id="element-296">
              <h3 className="text-lg font-black text-red-600 mb-4 text-center" style={{
              fontFamily: 'Montserrat, sans-serif'
            }} data-id="element-297">
                😩 ANTES de Fórmula UGC
              </h3>
              <div className="space-y-3 text-sm text-gray-800" data-id="element-298">
                <p data-id="element-299">
                  ❌ Te drenabas contactando en frío y persiguiendo clientas que
                  no compran
                </p>
                <p data-id="element-300">❌ Improvisabas contenido y terminabas agotada</p>
                <p data-id="element-301">❌ No lograbas cerrar nuevas ventas todas las semanas</p>
              </div>
            </div>
            <div className="bg-green-50 border-2 border-green-500 rounded-xl p-6" data-id="element-302">
              <h3 className="text-lg font-black text-green-700 mb-4 text-center" style={{
              fontFamily: 'Montserrat, sans-serif'
            }} data-id="element-303">
                😍 DESPUÉS de Fórmula UGC
              </h3>
              <div className="space-y-3 text-sm text-gray-800" data-id="element-304">
                <p data-id="element-305">✅ No perseguís más clientas, las atraés </p>
                <p data-id="element-306">✅ Tenés una estructura de contenido que SI VENDE</p>
                <p data-id="element-307">✅ Lográs cerrar nuevas ventas TODAS las semanas </p>
                <p data-id="element-308">✅ Tenés tiempo y energía para tu familia y otras tareas</p>
              </div>
            </div>
          </div>
        </section>

        {/* DIVIDER */}
        <div className="border-t-4 border-black my-2" data-id="element-309" />

        {/* TESTIMONIALS */}
        <section className="py-10 bg-[#FDF6EF]" data-id="element-310">
          <h2 className="text-2xl md:text-3xl font-black text-black text-center mb-8 uppercase" style={{
          fontFamily: 'Montserrat, sans-serif'
        }} data-id="element-311">
            Testimonios de emprendedoras que ya
            <br data-id="element-312" />
            <span className="text-[#10B981]" data-id="element-313">aplicaron Fórmula UGC:</span>
          </h2>

          <div className="space-y-5" data-id="element-314">
            <div className="bg-white border border-gray-200 rounded-xl p-6 shadow-md" data-id="element-315">
              <StarRating data-id="element-316" />
              <p className="text-gray-800 text-sm md:text-base italic mt-3 leading-relaxed" data-id="element-317">
                "Llevaba 8 meses en Nu Skin sin superar las 3 ventas al mes.
                Apliqué el Método de Fórmula UGC en mis Reels y en la segunda
                semana tuve 7 personas escribiéndome sin yo haberles escrito
                primero. Cerré 5 ventas en un sólo fin de semana, estoy
                feliiiiz!!"
              </p>
              <p className="text-gray-600 text-sm font-bold mt-3" data-id="element-318">
                — Valentina R. Córdoba, Argentina.
              </p>
            </div>

            <div className="bg-white border border-gray-200 rounded-xl p-6 shadow-md" data-id="element-319">
              <StarRating data-id="element-320" />
              <p className="text-gray-800 text-sm md:text-base italic mt-3 leading-relaxed" data-id="element-321">
                "Lo que más me cambió fue aprender a NO responder el precio
                directamente cuando me preguntan. Ese solo cambio de
                "informante" a "vender y ayudar al cliente" me permitió lograr
                cerrar 1 venta nueva en 5 días."
              </p>
              <p className="text-gray-600 text-sm font-bold mt-3" data-id="element-322">
                — Mariana T. Mendoza, Argentina.
              </p>
            </div>

            <div className="bg-white border border-gray-200 rounded-xl p-6 shadow-md" data-id="element-323">
              <StarRating data-id="element-324" />
              <p className="text-gray-800 text-sm md:text-base italic mt-3 leading-relaxed" data-id="element-325">
                "Tenía pánico de hablar a cámara. Con el programa me di cuenta
                de que mi baño era todo lo que necesitaba. Mi primer Video UGC
                llegó a 4,200 reproducciones y me trajo 5 consultas, 1
                compró!!!. Nunca había me pasado!! Gracias Bren!."
              </p>
              <p className="text-gray-600 text-sm font-bold mt-3" data-id="element-326">
                — Andrea L. Tucumán, Argentina.
              </p>
            </div>

            <div className="bg-white border border-gray-200 rounded-xl p-6 shadow-md" data-id="element-327">
              <StarRating data-id="element-328" />
              <p className="text-gray-800 text-sm md:text-base italic mt-3 leading-relaxed" data-id="element-329">
                "El script de DM para cuando preguntan el precio lo copié
                textual. Funcionó la primera vez que lo usé. La chica terminó
                comprando el kit completo, luego de seguir los pasos y no solo
                la LumiSpa."
              </p>
              <p className="text-gray-600 text-sm font-bold mt-3" data-id="element-330">
                — Camila P. CABA, Argentina.
              </p>
            </div>

            <div className="bg-white border border-gray-200 rounded-xl p-6 shadow-md" data-id="element-331">
              <StarRating data-id="element-332" />
              <p className="text-gray-800 text-sm md:text-base italic mt-3 leading-relaxed" data-id="element-333">
                "Agregué la Guía de Reclutamiento y Vende por Historias, y en 3
                semanas tuve 2 socias nuevas que llegaron solas después de ver
                mis Stories de negocio. Nunca las busqué. Ellas me escribieron
                primero y las cerré. Graciass!"
              </p>
              <p className="text-gray-600 text-sm font-bold mt-3" data-id="element-334">
                — Sofía M. Tierra del Fuego, Argentina.
              </p>
            </div>
          </div>
        </section>

        {/* DIVIDER */}
        <div className="border-t-4 border-black my-2" data-id="element-335" />

        {/* BONUSES SECTION */}
        <section className="py-10" id="compra" data-id="element-336">
          <div className="text-center mb-8" data-id="element-337">
            <span className="text-white font-black text-sm px-4 py-2 rounded-full uppercase tracking-wide bg-[#10B981]" style={{
            fontFamily: 'Montserrat, sans-serif'
          }} data-id="element-338">
              🎁 6 BONOS — SOLO POR HOY
            </span>
          </div>

          <h2 className="text-2xl md:text-3xl font-black text-black text-center mb-10 uppercase" style={{
          fontFamily: 'Montserrat, sans-serif'
        }} data-id="element-339">
            🎁 Bonos de REGALO incluidos HOY
          </h2>

          {/* Bonus 1 */}
          <div className="mb-10 text-center" data-id="element-340">
            <div className="inline-block font-black text-sm px-4 py-2 rounded-full mb-4 uppercase tracking-wide text-[#FFFFFF] bg-[#10B981]" style={{
            fontFamily: 'Montserrat, sans-serif'
          }} data-id="element-341">
              🎁 Bono #1
            </div>
            <h3 className="text-xl font-black text-black mb-2" style={{
            fontFamily: 'Montserrat, sans-serif'
          }} data-id="element-342">
              El Script Perfecto de DM
            </h3>
            <p className="text-green-600 font-bold mb-4" data-id="element-343">
              De "Hola, info" a "Ya pagué"
            </p>
            <div className="block" data-id="element-344">
              <img src={BONUS1_IMAGE} alt="Bono #1 - Script Perfecto de DM" className="w-full max-w-sm mx-auto rounded-xl shadow-lg" style={{
              width: '400px',
              height: '400px',
              objectFit: 'contain'
            }} data-id="element-345" />
            </div>
            <p className="text-gray-700 text-sm mt-4 max-w-md mx-auto" data-id="element-346">
              La secuencia de mensajes para convertir curiosidad en compra SIN
              sonar desesperada: qué decir, cuándo preguntar, cómo guiar, y cómo
              cerrar con seguridad.
            </p>
            <BonusPrice price="$14.990 ARS" data-id="element-347" />
          </div>

          {/* Bonus 2 */}
          <div className="mb-10 text-center" data-id="element-348">
            <div className="inline-block font-black text-sm px-4 py-2 rounded-full mb-4 uppercase tracking-wide text-[#FFFFFF] bg-[#10B981]" style={{
            fontFamily: 'Montserrat, sans-serif'
          }} data-id="element-349">
              🎁 Bono #2
            </div>
            <h3 className="text-xl font-black text-black mb-2" style={{
            fontFamily: 'Montserrat, sans-serif'
          }} data-id="element-350">
              Banco de Plantillas, Ideas y Recursos Listos para usar
            </h3>
            <div className="block" data-id="element-351">
              <img src={BONUS2_IMAGE} alt="Bono #2 - Banco de Plantillas" className="w-full max-w-sm mx-auto rounded-xl shadow-lg" style={{
              width: '400px',
              height: '400px',
              objectFit: 'contain'
            }} data-id="element-352" />
            </div>
            <p className="text-gray-700 text-sm mt-4 max-w-md mx-auto" data-id="element-353">
              Para que no empieces nunca más desde cero: plantillas y recursos
              para crear contenido UGC más rápido, con estructura, y con
              claridad de qué mostrar y cómo mostrarlo.
            </p>
            <BonusPrice price="$17.990 ARS" data-id="element-354" />
          </div>

          {/* Bonus 3 */}
          <div className="mb-10 text-center" data-id="element-355">
            <div className="inline-block font-black text-sm px-4 py-2 rounded-full mb-4 uppercase tracking-wide text-[#FFFFFF] bg-[#10B981]" style={{
            fontFamily: 'Montserrat, sans-serif'
          }} data-id="element-356">
              🎁 Bono #3
            </div>
            <h3 className="text-xl font-black text-black mb-2" style={{
            fontFamily: 'Montserrat, sans-serif'
          }} data-id="element-357">
              Calendario de Contenido que te ahorra HORAS de tu tiempo
            </h3>
            <div className="block" data-id="element-358">
              <img src={BONUS3_IMAGE} alt="Bono #3 - Calendario de Contenido" className="w-full max-w-sm mx-auto rounded-xl shadow-lg" style={{
              width: '400px',
              height: '400px',
              objectFit: 'contain'
            }} data-id="element-359" />
            </div>
            <p className="text-gray-700 text-sm mt-4 max-w-md mx-auto" data-id="element-360">
              Listo para organizar tu semana de publicaciones sin estrés: qué
              publicar cada día con el método probado UGC para atraer clientas.
            </p>
            <BonusPrice price="$19.990 ARS" data-id="element-361" />
          </div>

          {/* Bonus 4 */}
          <div className="mb-10 text-center" data-id="element-362">
            <div className="inline-block font-black text-sm px-4 py-2 rounded-full mb-4 uppercase tracking-wide text-[#FFFFFF] bg-[#10B981]" style={{
            fontFamily: 'Montserrat, sans-serif'
          }} data-id="element-363">
              🎁 Bono #4
            </div>
            <h3 className="text-xl font-black text-black mb-2" style={{
            fontFamily: 'Montserrat, sans-serif'
          }} data-id="element-364">
              Comunidad Privada de Alumnas Nu Skin UGC
            </h3>
            <p className="text-green-600 font-bold mb-4" data-id="element-365">
              Nunca más sola en el proceso
            </p>
            <div className="block" data-id="element-366">
              <img src={BONUS4_IMAGE} alt="Bono #4 - Comunidad Privada de Alumnas Nu Skin UGC" className="w-full max-w-sm mx-auto rounded-xl shadow-lg" style={{
              width: '400px',
              height: '400px',
              objectFit: 'cover'
            }} data-id="element-367" />
            </div>
            <p className="text-gray-700 text-sm mt-4 max-w-md mx-auto" data-id="element-368">
              Acceso exclusivo a un grupo privado de emprendedoras que están
              aplicando el método: comparten ideas, se apoyan, resuelven dudas y
              crecen juntas todos los días. Motivación y networking real.
            </p>
            <BonusPrice price="$24.990 ARS" data-id="element-369" />
          </div>

          {/* Bonus 5 */}
          <div className="mb-10 text-center" data-id="element-370">
            <div className="inline-block font-black text-sm px-4 py-2 rounded-full mb-4 uppercase tracking-wide text-[#FFFFFF] bg-[#10B981]" style={{
            fontFamily: 'Montserrat, sans-serif'
          }} data-id="element-371">
              🎁 Bono #5
            </div>
            <h3 className="text-xl font-black text-black mb-2" style={{
            fontFamily: 'Montserrat, sans-serif'
          }} data-id="element-372">
              Guía Completa: Cómo ser Embajadora de Viajes
            </h3>
            <p className="text-green-600 font-bold mb-4" data-id="element-373">
              Otra fuente de ingresos desde cero
            </p>
            <div className="block" data-id="element-374">
              <img src={BONUS5_IMAGE} alt="Bono #5 - Guía Cómo ser Embajadora de Viajes" className="w-full max-w-sm mx-auto rounded-xl shadow-lg" style={{
              width: '400px',
              height: '400px',
              objectFit: 'cover'
            }} data-id="element-375" />
            </div>
            <p className="text-gray-700 text-sm mt-4 max-w-md mx-auto" data-id="element-376">
              Aprende a viajar gratis y a generar otra fuente de ingresos desde
              cero como embajadora de viajes, combinando tu marca personal con
              el turismo. Un extra que multiplica tus oportunidades.
            </p>
            <BonusPrice price="$29.990 ARS" data-id="element-377" />
          </div>

          {/* Bonus 6 */}
          <div className="mb-10 text-center" data-id="element-378">
            <div className="inline-block font-black text-sm px-4 py-2 rounded-full mb-4 uppercase tracking-wide text-[#FFFFFF] bg-[#10B981]" style={{
            fontFamily: 'Montserrat, sans-serif'
          }} data-id="element-379">
              🎁 Bono #6
            </div>
            <h3 className="text-xl font-black text-black mb-2" style={{
            fontFamily: 'Montserrat, sans-serif'
          }} data-id="element-380">
              Masterclass de Edición en CapCut
            </h3>
            <p className="text-green-600 font-bold mb-4" data-id="element-381">
              Aprende a crear y editar contenido que vende
            </p>
            <div className="block" data-id="element-382">
              <img src={BONUS6_IMAGE} alt="Bono #6 - Masterclass de Edición en CapCut" className="w-full max-w-sm mx-auto rounded-xl shadow-lg" style={{
              width: '400px',
              height: '400px',
              objectFit: 'cover'
            }} data-id="element-383" />
            </div>
            <p className="text-gray-700 text-sm mt-4 max-w-md mx-auto" data-id="element-384">
              Paso a paso para editar tus Reels y videos UGC directamente desde
              el celular con CapCut: transiciones, textos, ritmo y cortes que
              retienen y convierten, sin programas complicados.
            </p>
            <BonusPrice price="$34.990 ARS" data-id="element-385" />
          </div>

          {/* SAVINGS SUMMARY */}
          <div className="max-w-xl mx-auto rounded-[32px] p-6 md:p-8 shadow-[0_8px_30px_rgb(0,0,0,0.08)] border-2 border-[#10B981] bg-[#FDF6EF]" data-id="element-386">
            <h3 className="text-xl md:text-2xl font-black text-black text-center mb-6 uppercase" style={{
            fontFamily: 'Montserrat, sans-serif'
          }} data-id="element-387">
              🎁 Todo lo que te llevás GRATIS hoy
            </h3>

            <div className="space-y-3" data-id="element-388">
              {BONUS_SAVINGS.map(bonus => <div key={bonus.n} className="flex items-center justify-between gap-3 rounded-xl px-4 py-3 border border-gray-100 bg-[#FDF6EF]" data-id="element-389">
                  <div className="flex items-start gap-2 min-w-0" data-id="element-390">
                    <span className="flex-shrink-0 text-[#10B981] font-black" data-id="element-391">
                      ✅
                    </span>
                    <span className="text-black font-bold text-sm md:text-base leading-snug" style={{
                  fontFamily: 'Montserrat, sans-serif'
                }} data-id="element-392">
                      Bono #{bonus.n}: {bonus.title}
                    </span>
                  </div>
                  <div className="flex flex-col items-end flex-shrink-0" data-id="element-393">
                    <span className="text-sm md:text-base font-black text-[#E11D48] line-through" data-id="element-394">
                      {bonus.price}
                    </span>
                    <span className="text-[11px] md:text-xs font-black text-[#10B981] uppercase tracking-wide" style={{
                  fontFamily: 'Montserrat, sans-serif'
                }} data-id="element-395">
                      Hoy Gratis
                    </span>
                  </div>
                </div>)}
            </div>

            <div className="mt-6 pt-5 border-t-2 border-dashed border-[#10B981] text-center" data-id="element-396">
              <p className="text-gray-700 text-sm md:text-base font-medium mb-1" data-id="element-397">
                Valor total de los 6 bonos:
              </p>
              <p className="text-2xl md:text-3xl font-black text-[#E11D48] line-through mb-2" style={{
              fontFamily: 'Montserrat, sans-serif'
            }} data-id="element-398">
                {TOTAL_BONUS_VALUE}
              </p>
              <p className="text-3xl md:text-4xl font-black text-[#10B981]" style={{
              fontFamily: 'Montserrat, sans-serif'
            }} data-id="element-399">
                HOY: $0 🎉
              </p>
              <p className="text-gray-700 text-sm md:text-base font-bold mt-3" data-id="element-400">
                Todos los bonos incluidos <strong data-id="element-401">GRATIS</strong> con la compra
                del programa completo Fórmula UGC.
              </p>
            </div>

            <div className="mt-8" data-id="element-402">
              <p className="text-sm text-gray-500 mt-3 text-center font-[900]" data-id="element-403">
                +500 Alumnas Nuskin ⭐⭐⭐⭐⭐
              </p>
            </div>
          </div>
        </section>

        {/* DIVIDER */}
        <div className="border-t-4 border-black my-2" data-id="element-404" />

        {/* URGENCY & SCARCITY */}
        <UrgencyScarcity data-id="element-405" />

        {/* PRICING SECTION - PREMIUM */}
        <section className="py-12 pt-[0px] pb-[0px] mt-[20px] mb-[20px]" id="precio" data-id="element-406">
          <div className="relative overflow-hidden rounded-[36px] p-6 md:p-10 shadow-2xl" style={{
          background: 'linear-gradient(180deg, #14121C 0%, #221B2C 100%)',
          border: '1px solid rgba(255,255,255,0.08)'
        }} data-id="element-407">
            {/* Neon glow accents */}
            <div className="absolute -top-10 left-1/2 -translate-x-1/2 w-64 h-40 rounded-full blur-[80px] opacity-40 pointer-events-none" style={{
            background: '#85C3D7'
          }} data-id="element-408" />
            <div className="absolute bottom-0 right-0 w-52 h-52 rounded-full blur-[90px] opacity-30 pointer-events-none" style={{
            background: '#D7B2D8'
          }} data-id="element-409" />

            {/* Pill tag */}
            <div className="relative z-10 flex justify-center mb-6" data-id="element-410">
              <span className="inline-flex items-center gap-2 px-6 py-3 rounded-full text-xs md:text-sm font-black tracking-[0.15em] uppercase text-white" style={{
              fontFamily: 'Montserrat, sans-serif',
              background: 'rgba(255,255,255,0.06)',
              border: '1px solid rgba(215,178,216,0.4)'
            }} data-id="element-411">
                <SparklesIcon className="w-4 h-4 text-[#D7B2D8]" data-id="element-412" />
                Valor por tiempo limitado
              </span>
            </div>

            {/* Subtitle */}
            <p className="relative z-10 text-center text-gray-300 text-base md:text-lg font-medium mb-3" data-id="element-413">
              ¡Este valor especial estará sólo por tiempo limitado!
            </p>

            {/* Neon headline */}
            <h2 className="relative z-10 text-center text-4xl md:text-5xl font-black mb-8 leading-none" style={{
            fontFamily: 'Montserrat, sans-serif',
            color: '#FFFFFF',
            textShadow: '0 0 12px rgba(133,195,215,0.9), 0 0 28px rgba(133,195,215,0.6), 0 0 48px rgba(133,195,215,0.4)'
          }} data-id="element-414">
              ACCEDÉ
              <br data-id="element-415" />
              AHORA
            </h2>

            {/* Product image on white card */}
            <div className="relative z-10 rounded-3xl p-6 md:p-8 shadow-xl bg-[#FDF6EF]" data-id="element-416">
              <img src={PRODUCT_IMAGE} alt="Fórmula UGC para Emprendedoras Nu Skin — todo lo que recibís" className="w-full max-w-sm mx-auto mb-6" data-id="element-417" />

              {/* Checklist */}
              <div className="space-y-4 text-left max-w-md mx-auto" data-id="element-418">
                {['Acceso Permanente', 'Soporte + Actualizaciones', '6 BONOS de regalo 🎁', 'Garantía de satisfacción'].map(item => <div key={item} className="flex items-center gap-3" data-id="element-419">
                    <span className="flex-shrink-0 w-6 h-6 rounded-full flex items-center justify-center" style={{
                  background: '#ECD7EB'
                }} data-id="element-420">
                      <CheckIcon className="w-4 h-4 text-[#B26FB4]" strokeWidth={3} data-id="element-421" />
                    </span>
                    <span className="text-black font-bold text-base" style={{
                  fontFamily: 'Montserrat, sans-serif'
                }} data-id="element-422">
                      {item}
                    </span>
                  </div>)}
              </div>

              {/* Premium included callout */}
              <div className="mt-8 max-w-md mx-auto" data-id="element-423">
                <div className="flex justify-center mb-[-14px] relative z-10" data-id="element-424">
                  <span className="inline-flex items-center gap-1.5 px-4 py-1.5 rounded-full text-xs font-black uppercase tracking-wide text-white bg-[#85C3D7]" style={{
                  fontFamily: 'Montserrat, sans-serif'
                }} data-id="element-425">
                    <SparklesIcon className="w-3.5 h-3.5" data-id="element-426" />
                    Premium incluido
                  </span>
                </div>
                <div className="rounded-2xl border-2 border-[#85C3D7] bg-[#F2FAFC] p-5 pt-6 flex items-start gap-3" data-id="element-427">
                  <span className="flex-shrink-0 w-8 h-8 rounded-full bg-[#85C3D7] flex items-center justify-center" data-id="element-428">
                    <VideoIcon className="w-4 h-4 text-white" data-id="element-429" />
                  </span>
                  <p className="text-black font-bold text-base leading-snug" style={{
                  fontFamily: 'Montserrat, sans-serif'
                }} data-id="element-430">
                    Comunidad de Emprendedoras en Whatsapp✨✨
                  </p>
                </div>
              </div>

              {/* Price block */}
              <div className="mt-8 text-center" data-id="element-431">
                <p className="text-lg md:text-xl font-black text-[#E11D48] line-through tracking-wide mb-1" style={{
                fontFamily: 'Montserrat, sans-serif'
              }} data-id="element-432">
                  ANTES $109.990 ARS
                </p>
                <p className="text-2xl md:text-3xl font-black text-black mb-2" style={{
                fontFamily: 'Montserrat, sans-serif'
              }} data-id="element-433">
                  ¡SÓLO POR HOY! 😱
                </p>
                <p className="text-5xl md:text-6xl font-black mb-4 text-[#10B981]" style={{
                fontFamily: 'Montserrat, sans-serif'
              }} data-id="element-434">
                  $49.990 ARS
                </p>

                {/* Recommended badge */}
                <div className="flex justify-center mb-4" data-id="element-435">
                  <span className="inline-flex items-center gap-2 px-5 py-2 rounded-full text-xs md:text-sm font-black uppercase tracking-wide text-[#FFFFFF] bg-[#10B981]" style={{
                  fontFamily: 'Montserrat, sans-serif'
                }} data-id="element-436">
                    100% Recomendado
                    <span className="text-[#FEF08A]" data-id="element-437">★★★★★</span>
                  </span>
                </div>

                <p className="text-gray-500 italic text-base mb-6" data-id="element-438">
                  - Hasta 3 cuotas -
                </p>

                {/* CTA */}
                <a href={PURCHASE_LINK} target="_blank" rel="noopener noreferrer" className="block w-full text-center text-white font-black py-5 px-6 rounded-2xl text-lg md:text-xl leading-tight transition-all duration-200 btn-pulse shadow-lg hover:shadow-xl hover:-translate-y-0.5 hover:bg-[#6FB4CA] bg-[#10B981]" style={{
                fontFamily: 'Montserrat, sans-serif'
              }} data-id="element-439">
                  ACCESO AHORA · 7 DÍAS DE GARANTÍA ⭐
                </a>

                <p className="text-gray-400 text-xs uppercase tracking-wide font-bold mt-4" data-id="element-440">
                  Compra 100% segura y protegida
                </p>

                {/* Payment / security badges */}
                <div className="mt-6 flex justify-center" data-id="element-441">
                  <img src="https://cdn.magicpatterns.com/uploads/k4VntiK44CTwkfjN5W9XsF/pasted-image.jpg" alt="Mercado Pago · Site seguro SSL · Compra 100% segura" className="w-full max-w-xs object-contain" data-id="element-442" />
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* ORDER BUMP - Below main offer */}

        {/* DIVIDER */}

        {/* GUARANTEE */}
        {/* PREMIUM GUARANTEE SECTION */}
        <section className="py-16 px-4 pt-[15px] pb-[15px]" data-id="element-443">
          <div className="max-w-xl mx-auto rounded-[40px] p-10 text-center relative overflow-hidden shadow-2xl" style={{
          background: 'linear-gradient(180deg, #0F111A 0%, #1A1D29 100%)',
          border: '1px solid rgba(255, 255, 255, 0.1)'
        }} data-id="element-444">
            {/* Neon Glow behind icon */}
            <div className="absolute top-0 left-1/2 -translate-x-1/2 w-40 h-40 rounded-full blur-[60px] opacity-40 pointer-events-none" style={{
            background: '#85C3D7'
          }} data-id="element-445" />

            {/* Icon Container */}
            <div className="relative z-10 mb-8 flex justify-center" data-id="element-446">
              <div className="w-20 h-20 rounded-2xl flex items-center justify-center shadow-lg" style={{
              background: 'linear-gradient(135deg, #D7B2D8 0%, #B28DB3 100%)'
            }} data-id="element-447">
                <svg width="40" height="40" viewBox="0 0 24 24" fill="none" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" data-id="element-448">
                  <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z" data-id="element-449" />
                </svg>
              </div>
            </div>

            {/* Title */}
            <h2 className="md:text-3xl font-black mb-10 tracking-tight text-[#EAB308] text-[25px]" style={{
            fontFamily: 'Montserrat, sans-serif'
          }} data-id="element-450">
              GARANTÍA 7 DÍAS — <br data-id="element-451" />
              SIN PREGUNTAS
            </h2>

            {/* Content Box */}
            <div className="rounded-3xl p-8 mb-8 border relative z-10" style={{
            background: 'rgba(255, 255, 255, 0.03)',
            borderColor: 'rgba(255, 255, 255, 0.1)'
          }} data-id="element-452">
              <div className="space-y-6 text-gray-300 text-lg md:text-xl font-medium leading-relaxed" data-id="element-453">
                <p data-id="element-454">Accedes al programa. Lo aplicás en tus videos de Nu Skin.</p>
                <p data-id="element-455">Si en 7 días no es exactamente lo que esperabas:</p>

                <div className="text-3xl md:text-4xl font-black py-4 text-[#D7B2D8]" style={{
                fontFamily: 'Montserrat, sans-serif'
              }} data-id="element-456">
                  devolución <br data-id="element-457" />
                  del 100%
                </div>

                <p className="text-white font-bold" data-id="element-458">
                  sin formularios, sin drama, sin explicaciones.
                </p>
              </div>
            </div>

            {/* Footer Stats */}
            <p className="text-gray-400 text-sm md:text-base font-medium relative z-10" data-id="element-459">
              Tasa de devoluciones:{' '}
              <span style={{
              color: '#D7B2D8'
            }} data-id="element-460">
                menos del 1%.
              </span>
            </p>
          </div>
        </section>

        {/* DOUBTS / WHATSAPP SUPPORT */}
        <section className="py-6 px-4" data-id="element-461">
          <div className="max-w-md mx-auto rounded-[36px] p-8 md:p-10 text-center relative overflow-hidden shadow-2xl" style={{
          background: 'linear-gradient(180deg, #0F111A 0%, #1A1D29 100%)',
          border: '1px solid rgba(255, 255, 255, 0.1)'
        }} data-id="element-462">
            <h2 className="text-3xl md:text-4xl font-black leading-tight mb-8" style={{
            fontFamily: 'Montserrat, sans-serif'
          }} data-id="element-463">
              <span className="text-white" data-id="element-464">¿Dudas?</span>
              <br data-id="element-465" />
              <span style={{
              background: 'linear-gradient(90deg, #85C3D7 0%, #D7B2D8 100%)',
              WebkitBackgroundClip: 'text',
              WebkitTextFillColor: 'transparent',
              backgroundClip: 'text'
            }} data-id="element-466">
                ¡Comunícate conmigo!
              </span>
            </h2>

            <a href="https://wa.me/5491169196692?text=Hola%20Bren%2C%20soy%20emprendedora%20NuSkin%20y%20quiero%20ingresar%20a%20F%C3%B3rmula%20UGC.%20Mi%20nombre%20es%20...." target="_blank" rel="noopener noreferrer" className="inline-flex items-center justify-center gap-3 font-black text-lg md:text-xl text-white px-8 py-4 rounded-full shadow-lg transition-all duration-200 hover:-translate-y-0.5 hover:shadow-xl" style={{
            fontFamily: 'Montserrat, sans-serif',
            background: '#10B981',
            border: '1px solid rgba(255,255,255,0.25)'
          }} data-id="element-467">
              <span className="flex-shrink-0 w-9 h-9 rounded-full flex items-center justify-center bg-[#FFFFFF]" data-id="element-468">
                <svg width="20" height="20" viewBox="0 0 24 24" fill="#25D366" aria-hidden="true" data-id="element-469">
                  <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.174.198-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51l-.57-.01c-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.71.306 1.263.489 1.694.626.712.226 1.36.194 1.872.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413z" data-id="element-470" />
                </svg>
              </span>
              Whatsapp Soporte
            </a>
          </div>
        </section>

        {/* DIVIDER */}

        {/* COST OF INACTION */}
        <section className="py-14 px-1 pt-[25px] pb-[25px]" data-id="element-471">
          <div className="max-w-2xl mx-auto rounded-[36px] p-6 md:p-10 relative overflow-hidden shadow-2xl" style={{
          background: 'linear-gradient(180deg, #0F111A 0%, #1A1D29 100%)',
          border: '1px solid rgba(255, 255, 255, 0.1)'
        }} data-id="element-472">
            {/* Glow accent */}
            <div className="absolute -top-10 right-0 w-52 h-52 rounded-full blur-[80px] opacity-30 pointer-events-none" style={{
            background: '#D7B2D8'
          }} data-id="element-473" />

            {/* Title */}
            <h2 className="relative z-10 text-3xl md:text-5xl font-black text-center leading-tight mb-5" style={{
            fontFamily: 'Montserrat, sans-serif'
          }} data-id="element-474">
              <span className="text-white" data-id="element-475">🤔 ¿CUÁNTO CUESTA</span>
              <br data-id="element-476" />
              <span style={{
              color: '#D7B2D8'
            }} data-id="element-477">
                NO TENERLO?
              </span>
            </h2>

            <p className="relative z-10 text-gray-300 text-center text-sm md:text-base leading-relaxed max-w-md mx-auto mb-8" data-id="element-478">
              Cada semana que seguís sin un método probado, también tiene un
              precio. Esto es lo que realmente estás pagando al no tomar acción:
            </p>

            {/* Comparison table */}
            <div className="relative z-10 rounded-3xl overflow-hidden border" style={{
            background: 'rgba(255, 255, 255, 0.03)',
            borderColor: 'rgba(255, 255, 255, 0.1)'
          }} data-id="element-479">
              {/* Header row */}
              <div className="grid grid-cols-2" data-id="element-480">
                <div className="px-4 md:px-6 py-4 text-xs md:text-sm font-black uppercase tracking-wide text-white border-b border-r" style={{
                fontFamily: 'Montserrat, sans-serif',
                borderColor: 'rgba(255,255,255,0.1)'
              }} data-id="element-481">
                  Sin Fórmula UGC
                </div>
                <div className="px-4 md:px-6 py-4 text-xs md:text-sm font-black uppercase tracking-wide border-b" style={{
                fontFamily: 'Montserrat, sans-serif',
                color: '#D7B2D8',
                borderColor: 'rgba(255,255,255,0.1)'
              }} data-id="element-482">
                  Costo Real
                </div>
              </div>

              {/* Rows */}
              {[{
              problem: 'Publicás tus videos sin un método claro',
              cost: 'Horas perdidas grabando contenido que no vende'
            }, {
              problem: 'Buscás tips gratis y dispersos en redes',
              cost: 'Meses estancada, sin claridad ni resultados'
            }, {
              problem: 'Improvisás a prueba y error, sin estructura',
              cost: 'Contenido que las clientas ignoran'
            }, {
              problem: 'No sabés qué responder cuando te preguntan el precio',
              cost: 'Ventas que se enfrían y clientas que desaparecen'
            }, {
              problem: 'Seguís persiguiendo clientas una por una',
              cost: 'Te agotás y tus ventas no crecen'
            }, {
              problem: 'No lográs mostrar autoridad ni ser referente',
              cost: 'Nadie confía ni te compra a vos'
            }, {
              problem: 'Sin comunidad ni acompañamiento que te sostenga',
              cost: 'Te frustrás y abandonás tu negocio Nu Skin'
            }, {
              problem: 'Seguís en la misma rutina que no te llena',
              cost: 'Otro mes igual: sin ventas ni subir de rango'
            }].map((row, i, arr) => <div key={i} className={`grid grid-cols-2 ${i !== arr.length - 1 ? 'border-b' : ''}`} style={{
              borderColor: 'rgba(255,255,255,0.08)'
            }} data-id="element-483">
                  <div className="px-4 md:px-6 py-5 flex items-start gap-2 border-r" style={{
                borderColor: 'rgba(255,255,255,0.08)'
              }} data-id="element-484">
                    <XIcon className="w-4 h-4 flex-shrink-0 mt-0.5" strokeWidth={3} style={{
                  color: '#D7B2D8'
                }} data-id="element-485" />
                    <span className="text-white font-bold text-xs md:text-sm leading-snug" style={{
                  fontFamily: 'Montserrat, sans-serif'
                }} data-id="element-486">
                      {row.problem}
                    </span>
                  </div>
                  <div className="px-4 md:px-6 py-5 flex items-start gap-2" data-id="element-487">
                    <CornerDownRightIcon className="w-4 h-4 flex-shrink-0 mt-0.5" strokeWidth={3} style={{
                  color: '#D7B2D8'
                }} data-id="element-488" />
                    <span className="font-bold text-xs md:text-sm leading-snug" style={{
                  fontFamily: 'Montserrat, sans-serif',
                  color: '#D7B2D8'
                }} data-id="element-489">
                      {row.cost}
                    </span>
                  </div>
                </div>)}
            </div>

            {/* Closing line */}
            <p className="relative z-10 text-center text-white italic font-bold text-lg md:text-2xl leading-relaxed mt-9 max-w-lg mx-auto" style={{
            fontFamily: 'Georgia, serif'
          }} data-id="element-490">
              La pregunta no es cuánto cuesta el programa…{' '}
              <span style={{
              color: '#D7B2D8'
            }} data-id="element-491">
                es cuánto te cuesta seguir como estás.
              </span>
            </p>
          </div>
        </section>

        {/* DIVIDER */}
        <div className="border-t-4 border-black my-2" data-id="element-492" />

        {/* FAQ */}
        <section className="py-12 pt-[20px] pb-[20px]" data-id="element-493">
          <div className="text-center mb-10" data-id="element-494">
            <span className="inline-block text-xs md:text-sm font-bold px-4 py-2 rounded-full uppercase tracking-widest text-[#FFFFFF] bg-[#85C3D7] mb-5" style={{
            fontFamily: 'Montserrat, sans-serif'
          }} data-id="element-495">
              ¿Tenés dudas?
            </span>
            <h2 className="text-4xl md:text-6xl font-black text-black leading-none uppercase" style={{
            fontFamily: 'Montserrat, sans-serif'
          }} data-id="element-496">
              Preguntas
              <br data-id="element-497" />
              <span className="text-[#85C3D7]" data-id="element-498">Frecuentes</span>
            </h2>
            <p className="text-gray-500 text-sm md:text-base mt-4 max-w-md mx-auto" data-id="element-499">
              Tocá cada pregunta para ver la respuesta.
            </p>
          </div>

          <FaqAccordion data-id="element-500" />
        </section>

        {/* TWO FUTURES */}
        <section className="py-10 pt-[0px] pb-[0px]" data-id="element-501">
          <h2 className="text-2xl md:text-3xl font-black text-black text-center mb-8 pt-[10px] pb-[10px]" style={{
          fontFamily: 'Montserrat, sans-serif'
        }} data-id="element-502">
            Hay dos versiones de vos dentro de 30 días 👇🏻
          </h2>
          <div className="grid md:grid-cols-2 gap-6" data-id="element-503">
            <div className="border-2 border-gray-400 rounded-xl p-6 bg-[#FFDDDD]" data-id="element-504">
              <p className="text-2xl text-center mb-3" data-id="element-505">😭</p>
              <p className="text-sm text-gray-700 leading-relaxed" data-id="element-506">
                Seguís enviando difusiones de Whatsapp que nadie responde.
                Seguís publicando fotos "catálogo" que el algoritmo ignora. Y lo
                peor de todo: seguís sin ventas y viendo cómo otras socias sí
                crecen cada mes... sin entender qué están haciendo diferente.
              </p>
            </div>
            <div className="bg-green-50 border-2 border-green-500 rounded-xl p-6" data-id="element-507">
              <p className="text-2xl text-center mb-3" data-id="element-508">😍</p>
              <p className="text-sm text-gray-700 leading-relaxed" data-id="element-509">
                Abrís Instagram por la mañana y tenés 7 mensajes nuevos de
                mujeres preguntando por los kits. Tenés un sistema de Contenido
                UGC que te genera ventas todas las semanas. Al fin tenes nuevas
                socias que llegaron solas. Tenés claridad sobre qué publicar,
                cómo estructurarlo y qué decir cuando alguien te escribe.
              </p>
            </div>
          </div>
        </section>

        {/* FINAL CTA */}
        <section className="py-10 text-center pt-[20px] pb-[20px]" data-id="element-510">
          <div className="bg-black text-white rounded-2xl p-8 mb-6" data-id="element-511">
            <h2 className="text-2xl md:text-3xl font-black mb-4" style={{
            fontFamily: 'Montserrat, sans-serif'
          }} data-id="element-512">
              ¿Estás lista para que las clientas
              <br data-id="element-513" />
              <span className="bg-[#10B981] text-[#FFFFFF]" data-id="element-514">
                te persigan a VOS?
              </span>
            </h2>
            <p className="text-gray-300 mb-6 text-base" data-id="element-515">
              Acceso inmediato · Garantía 7 días · Un solo pago
            </p>
            <a href={PURCHASE_LINK} target="_blank" rel="noopener noreferrer" className="block w-full text-center bg-green-500 hover:bg-green-400 text-white font-black py-6 px-6 rounded-lg text-xl leading-tight transition-all duration-200 btn-pulse shadow-xl" style={{
            fontFamily: 'Montserrat, sans-serif'
          }} data-id="element-516">
              👉 ¡SÍ, QUIERO ACCEDER AHORA!
              <br data-id="element-517" />
              <span className="text-base font-bold opacity-90" data-id="element-518">
                (Acceso inmediato)
              </span>
            </a>
            <p className="text-gray-400 text-sm mt-4" data-id="element-519">
              🔥 HOY: $49.990 ARS · Acceso inmediato · +500 Alumnas Nuskin
              ⭐⭐⭐⭐⭐
            </p>
          </div>
        </section>

        {/* FOOTER */}
        <footer className="py-8 border-t border-gray-200 text-center pt-[0px] pb-[0px]" data-id="element-520">
          <p className="text-gray-500 text-xs leading-relaxed" data-id="element-521">
            © Fórmula UGC para Emprendedoras Nu Skin. Todos los derechos
            reservados.
            <br data-id="element-522" />
            <em data-id="element-523">
              Este producto es independiente y no está afiliado, patrocinado ni
              respaldado por Nu Skin Enterprises Inc.
            </em>
          </p>
        </footer>
      </div>

      {/* Social Proof Popup */}
      <SocialProofPopup data-id="element-524" />
    </div>;
}